import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PoDynamicViewField } from '@po-ui/ng-components';
import { Observable, firstValueFrom, switchMap, take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LiteralsService } from './literals-service';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { IDownloadInvoiceAPI, IInvoiceCityState, IInvoiceUrl, IInvoicesAPI } from '../interfaces/Iinvoices';
import { NetworkService } from './network.service';

@Injectable({
  providedIn: 'root'
})
export class InvoicesService {
  public literals: LiteralsWords;
  public is401: boolean;
  public msgError: string;
  public descError: string;

  constructor(
    private http: HttpClient,
    private literalsService: LiteralsService,
    private networkService: NetworkService

  ) {
    this.literals = this.literalsService.getLiteralModule()
  }

  isOnline(): boolean {
    return this.networkService.getConnectionStatus().status;
  }

  getFields(): PoDynamicViewField[] {
    return [
      { property: 'invoicetype', label: this.literals.str0852, gridColumns: 12, gridSmColumns: 12 },
      { property: 'invoice', label: this.literals.str0851, gridColumns: 6, gridSmColumns: 12 },
      { property: 'serie', label: this.literals.str0854, gridColumns: 6, gridSmColumns: 12 },
      { property: 'customer', label: this.literals.str0011, gridColumns: 6, gridSmColumns: 12 },
      { property: 'customerstore', label: this.literals.str0145, gridColumns: 6, gridSmColumns: 12 },
      { property: 'amount', label: this.literals.str0303, gridColumns: 12, gridSmColumns: 12 },
      { property: 'invoicekey', label: this.literals.str0860, gridColumns: 12, gridSmColumns: 12 }
    ];
  }

  getInvoiceFromSalesOrders(orderid: string, page: number): Promise<IInvoicesAPI> {
    const data$ = this.getFromSalesOrders(orderid, page);
    return firstValueFrom(data$);
  }

  getFromSalesOrders(orderid: string, page: number): Observable<IInvoicesAPI> {
    return this.http.get<IInvoicesAPI>(`${environment.url}api/tgv/salesorders/invoices/${orderid}?page=${page}`);
  }

  getStateAndCity(branch: string): Observable<IInvoiceUrl> {
    return this.http.get<IInvoiceCityState>(`${environment.url}api/pc/v1/issuerData/${branch}`).pipe(
      switchMap((res: IInvoiceCityState) => {
        return this.http.get<IInvoiceUrl>(
          `${environment.url}api/fin/v1/tabledata/alias/F7H?fields=f7h_urlpre,f7h_codmun,f7h_est&filter=f7h_est%20eq%20%27${res.issuerState}%27%20and%20f7h_codmun%20eq%20%27${res.issuerCityCode}%27&page=1&pagesize=1`
        );
      })
    );
  }

  getDownloadInvoice(serie: string, invoice: string, invoicekey: string): Observable<IDownloadInvoiceAPI> {
    const model = invoicekey.substring(20, 22);
    // Documentacao referente a estrutura do tamanho dos campos a serem enviados para a API do TSS tssapidoc/v2/nfe/retornadoc
    // chamada por api/pc/v1/invoices/nfe:
    // TSSAPIDOC - API REST para retorno de DANFE e do XML referente a integração com o Portal Financeiro
    // https://tdn.totvs.com/pages/viewpage.action?pageId=811237572#apirest--23598164
    serie = serie.padEnd(3, ' ').replaceAll(' ', '%20');
    invoice = invoice.padEnd(9, ' ').replaceAll(' ', '%20');

    return this.http
      .get<IDownloadInvoiceAPI>(
        `${environment.url}api/pc/v1/invoices/nfe?serie=${serie}&numero=${invoice}&modelo=${model}`
      ).
      pipe(take(1));
  }
}
